import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["selectedStarsCounter", "submitBtn"];

  connect() {}


  selectStars(e) {
    var currentStarN = parseInt(e.target.dataset.starN);
    this.element.querySelectorAll(".feedback-star").forEach((star) => {
      var starN = parseInt(star.dataset.starN);
      // console.log("star", starN);

      if (starN > currentStarN) {
        star.classList.remove("fill-yellow-500");
      } else {
        star.classList.add("fill-yellow-500");
      }
    });
  }

  deselectStars(e) {
    for (let i = 0; i < 5; i++) {
      var star = this.element.querySelector(`.feedback-star[data-star-n="${i + 1}"]:not([data-star-selected="true"])`);
      if (!!star) star.classList.remove("fill-yellow-500");
    }


  }

  confirmStarsSelection(e) {
    var selectedStarN = parseInt(e.target.dataset.starN);
    this.element.querySelectorAll(".feedback-star").forEach((star) => {
      var starN = parseInt(star.dataset.starN);


      if (selectedStarN == 1 && e.target.dataset.starSelected == "true") {

        star.dataset.starSelected = false;
      } else {
        if (starN <= selectedStarN) {
          {
            star.dataset.starSelected = true;
          }
        } else {
          star.dataset.starSelected = false;
        }
      }


    })


    var selectedStarsCount = this.element.querySelectorAll(`.feedback-star[data-star-selected="true"]`).length;
    this.selectedStarsCounterTarget.value = selectedStarsCount;
    
    if (selectedStarsCount > 0) {
      this.submitBtnTarget.classList.remove("opacity-40");
      
      // this.submitBtnTarget.disabled = false;
    } else {
      this.submitBtnTarget.classList.add("opacity-40");
      // this.submitBtnTarget.disabled = true;
    }
    
    
  }


  toggleTextarea() {
    this.textareaTarget.classList.toggle("hidden");
  }


  checkSelection(e) {
    var selectedStarsCount = this.element.querySelectorAll(`.feedback-star[data-star-selected="true"]`).length;
    if (selectedStarsCount > 0) {
      this.selectionErrorTextTarget.classList.add("hidden");
      this.submitBtnTarget.classList.remove("opacity-40");
    } else {
      this.selectionErrorTextTarget.classList.remove("animate__animated");
      this.selectionErrorTextTarget.classList.add("animate__animated");
      this.selectionErrorTextTarget.classList.remove("hidden");
      this.submitBtnTarget.classList.add("opacity-40");
      e.preventDefault();
    }


  }

}